import type { ReactNode } from 'react';

import { PlaneBackgroundContainer } from './PlaneBackground.styles';
import type { PlaneBackgroundStyle } from './PlaneBackground.styles';

type PlaneBackgroundProps = {
  children: ReactNode;
  backgroundStyle?: PlaneBackgroundStyle;
};

const PlaneBackground = ({
  children,
  backgroundStyle = 'green',
}: PlaneBackgroundProps) => (
  <PlaneBackgroundContainer backgroundStyle={backgroundStyle}>
    {children}
  </PlaneBackgroundContainer>
);

export { PlaneBackground };
export type { PlaneBackgroundStyle };
